import { Box } from '@arpeggi/ui'
import { useContext } from 'react'
import { ModalComponents } from '../../../core/Modal'
import { FileItem, WavFilePicker } from './components'
import { RegisterModalContext } from './RegisterSongModal'

export const UploadWavPage = () => {
  const { state, clearWavFile } = useContext(RegisterModalContext)

  return (
    <>
      <ModalComponents.HeaderContainer>
        <ModalComponents.Title>Upload a .wav file of your finished song.</ModalComponents.Title>
        <ModalComponents.Subtitle>
          You will receive a playable NFT of your song for free.
        </ModalComponents.Subtitle>
      </ModalComponents.HeaderContainer>
      <ModalComponents.Container>
        <Box column>
          <WavFilePicker />
          {state.wavFileField.value && (
            <FileItem.Success
              file={state.wavFileField.value}
              handleDelete={(_file) => clearWavFile()}
            />
          )}
          {state.wavFileField.errors?.map((error, index) => (
            <FileItem.Error fileError={error} key={index} />
          ))}
        </Box>
      </ModalComponents.Container>
    </>
  )
}
